import { head } from 'ramda'
import React from 'react'

import { SmallText, Title } from '../../../packages/kiti/components/presentation/Text'
import { useReplies } from './_load/RepliesLoader'

const ModalHeader = () => {
  const replies = useReplies()
  const firstReply = head(replies)

  return (
    <>
      <Title size="h4" align="center" noMargin>
        {firstReply?.question?.name}
      </Title>
      <SmallText align="center">{firstReply?.question?.category?.name}</SmallText>
    </>
  )
}

export default ModalHeader
